<template>
  <div>
    <LoadingSpinner v-if="!loadingGeneral" />
    <div v-else>
      <div
        class="row ml-1"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="row w-100">
          <div class="col-md-6 mt-3">
            <h5>{{ $t("lang.column.aboutthedecisionmakersyoutarget") }}</h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <select
                  v-model="selected.user.booker_level_id"
                  class="form-control"
                >
                  <option
                    v-for="level in booker_level"
                    :key="level.id"
                    :value="level.id"
                  >
                    {{ level.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <h5 class="mr-1 text-capitalize">
              {{ $t("lang.label.starting_date") }}
            </h5>
            <div class="row">
              <div class="col-md-9 mb-3" v-if="userSelectedIsBdrUser">
                <date-picker
                  id="startDatePicker"
                  class="form-control"
                  v-model="selected.user.starting_date"
                  :config="datePickerConfig"
                  placeholder="Starting Date"
                ></date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row ml-1"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="row w-100">
          <div class="col-md-6 mt-3">
            <h5>{{ $t("lang.column.status") }}</h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <select
                  v-model="selected.user.user_bdr_status_id"
                  class="form-control"
                >
                  <option
                    v-for="status of booker_statuses"
                    :key="status.id"
                    :value="status.id"
                    :disabled="isRejectedStatusBlocked(status.id)"
                  >
                    {{ status.name }}
                  </option>
                </select>
                <small
                  v-if="selected.user.booker_has_worked"
                  class="text-muted d-block mt-1"
                >
                  {{ bookerAlreadyWorkedMessage }}
                </small>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <h5 class="mr-1 text-capitalize">
              {{ $t("lang.label.last_changes_booker") }}
            </h5>
            <div class="row">
              <div class="col-md-9 mb-3" v-if="userSelectedIsBdrUser">
                <date-picker
                  id="startDatePicker"
                  class="form-control"
                  v-model="selected.user.status_date"
                  :config="datePickerConfig"
                  placeholder="Date"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row ml-1"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="row w-100">
          <div class="col-md-6 mt-3">
            <h5 class="mr-1">Booker Type</h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <select
                  v-model="selected.user.booker_type"
                  class="form-control"
                >
                  <option value="human">Human</option>
                  <option value="ai_agent">AI Agent</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <h5 class="mr-1">Papaya Beneficiary ID</h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <input
                  v-model.trim="selected.user.papaya_beneficiary_id"
                  class="form-control"
                  type="text"
                  maxlength="255"
                  autocomplete="off"
                  placeholder="Papaya Beneficiary ID"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row ml-1"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="row w-100">
          <div class="col-md-6 mt-3">
            <h5 class="mr-1">Booker Manager</h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <select
                  v-model="selected.user.booker_manager_id"
                  class="form-control"
                  :disabled="selected.user.user_bdr_status_id == 6"
                >
                  <option
                    v-for="manager in booker_manager"
                    :key="manager.id"
                    :value="manager.id"
                  >
                    {{ manager.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <h5 class="mr-1 text-capitalize">
              {{ $t("lang.label.setup_booker_calls") }}
            </h5>
            <div class="row">
              <div class="col-md-9 mb-3" v-if="userSelectedIsBdrUser">
                <select v-model="selected.user.setup_call" class="form-control">
                  <option
                    v-for="calls in booker_calls_setup"
                    :key="calls.id"
                    :value="calls.id"
                  >
                    {{ calls.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row ml-1"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="row w-100">
          <div class="col-md-6 mt-3">
            <h5 class="mr-1">{{ $t("lang.label.country") }}</h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <select
                  v-model="selected.user.country_id"
                  class="form-control"
                >
                  <option value="">Select Country</option>
                  <option
                    v-for="country in countries"
                    :key="country.id"
                    :value="country.id"
                  >
                    {{ country.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <h5>Recruiter</h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <select
                  v-model="selected.user.recruiter_id"
                  class="form-control"
                >
                  <option :value="null">None</option>
                  <option
                    v-for="recruiter in recruiters"
                    :key="recruiter.id"
                    :value="recruiter.id"
                  >
                    {{ recruiter.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row ml-1"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="row w-100">
          <div class="col-md-6 mt-3">
            <h5>
              Discord Id
              <span v-if="discordRequired" class="text-danger">*</span>
            </h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <input
                  v-model.trim="selected.user.discord_id"
                  class="form-control"
                  :class="{ 'is-invalid': discordRequired && !selected.user.discord_id }"
                  type="text"
                  placeholder="Discord Id"
                  :required="discordRequired"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <h5>Ringover Phone</h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <input
                  v-model="selected.user.ringover_phone"
                  class="form-control"
                  type="number"
                  placeholder="Ringover Phone"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row ml-1"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <div class="row w-100">
          <div class="col-md-6 mt-3">
            <h5 class="mr-1">{{ $t("lang.label.notes") }}</h5>
            <div class="row">
              <div class="col-md-9 mb-3">
                <textarea
                  v-model="selected.user.booker_notes"
                  class="form-control"
                  rows="10"
                  placeholder="Write notes here ..."
                ></textarea>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div
              class="col-md-9 my-4 text-center"
              v-if="active || !selected.user.verificationcode"
            >
              <div class="card p-4">
                <h5 class="my-2" v-if="!hasPermissions('isAgencyManager')">
                  <span class="mr-2"> Account Verified </span>
                  <i class="text-success icon-checkmark"></i>
                </h5>
                <div v-if="selected.user.login_attempt < 4">
                  <div>
                    <h5>
                      <span class="mr-2"> Account Active </span>
                      <i class="text-success icon-checkmark"></i>
                    </h5>
                    <small
                      >Remaining attempts:
                      {{ 4 - selected.user.login_attempt }}
                    </small>
                  </div>
                </div>
                <div v-if="selected.user.login_attempt == 4">
                  <div>
                    <h5>
                      <span class="mr-2"> Account Blocked </span>
                      <i class="text-danger icon-close"></i>
                    </h5>
                    <small class="text-danger"
                      >( Account locked for repeated attempts )</small
                    >
                  </div>
                  <button
                    @click="unBlock()"
                    class="mt-3 btn btn-sm btn-success"
                  >
                    unblock
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-md-9 my-4 text-center"
              v-if="!active && selected.user.verificationcode"
            >
              <div class="card p-4">
                <h5 class="my-2">
                  <span class="mr-2"> Account not verified yet. </span>
                  <i class="text-danger icon-close"></i>
                </h5>
                <h5>
                  Code verification
                  <small class="ml-1">
                    {{ selected.user.verificationcode }}
                  </small>
                </h5>
                <button
                  @click="approveVerification()"
                  class="ml-1 btn btn-sm btn-primary"
                >
                  Force activation
                  <i class="text-white icon-checkmark"></i>
                </button>
                <small class="ml-1">
                  active this account without verification.</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <button
          @click="saveInfoUserGeneral()"
          class="btn btn-primary w-25 my-3 font-weight-bold rounded-pill"
        >
          {{ $t("lang.button.update") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { usersService, bookersService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from "moment";

export default {
  props: {
    selected: {
      type: Object,
    },
    selectedUserId: {
      type: String,
      default: null,
    },
  },
  components: {
    LoadingSpinner,
  },
  data() {
    self = this;
    return {
      loadingGeneral: false,
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
      },
      booker_statuses: null,
      booker_manager: [
        { id: null, name: self.$t("lang.column.no_booker_manager") },
      ],
      active: false,
      booker_calls_setup: [
        { id: "1", label: "1" },
        { id: "2", label: "2" },
        { id: "3", label: "3" },
        { id: "4", label: "4" },
        { id: "5", label: "5" },
        { id: "6", label: "6" },
        { id: "7", label: "7" },
        { id: "8", label: "8" },
        { id: "9", label: "9" },
        { id: "10", label: "10" },
        { id: "11", label: "11" },
        { id: "12", label: "12" },
        { id: "13", label: "13" },
        { id: "14", label: "14" },
        { id: "15", label: "15" },
        { id: "16", label: "16" },
        { id: "17", label: "17" },
        { id: "18", label: "18" },
        { id: "19", label: "19" },
        { id: "20", label: "20" },
      ],
      booker_level: [
        { id: 1, label: "1" },
        { id: 2, label: "2" },
        { id: 3, label: "3" },
        { id: 4, label: "4" },
        { id: 5, label: "5" },
        { id: 6, label: "6" },
        { id: 7, label: "7" },
        { id: 8, label: "8" },
        { id: 9, label: "9" },
        { id: 10, label: "10" },
      ],
      countries: [
        { id: 2, name: "Albania" },
        { id: 3, name: "Algeria" },
        { id: 18, name: "Bangladesh" },
        { id: 21, name: "Belgium" },
        { id: 23, name: "Benin" },
        { id: 34, name: "Burkina Faso" },
        { id: 36, name: "Cambodia" },
        { id: 37, name: "Cameroon" },
        { id: 47, name: "Colombia" },
        { id: 49, name: "Congo" },
        { id: 52, name: "Costa Rica" },
        { id: 53, name: "Cote D'Ivoire" },
        { id: 61, name: "Dominican Republic" },
        { id: 73, name: "France" },
        { id: 77, name: "Gabon" },
        { id: 80, name: "Germany" },
        { id: 99, name: "India" },
        { id: 100, name: "Indonesia" },
        { id: 105, name: "Italy" },
        { id: 110, name: "Kenya" },
        { id: 127, name: "Madagascar" },
        { id: 131, name: "Mali" },
        { id: 136, name: "Mauritius" },
        { id: 138, name: "Mexico" },
        { id: 144, name: "Morocco" },
        { id: 150, name: "Netherlands" },
        { id: 156, name: "Nigeria" },
        { id: 162, name: "Pakistan" },
        { id: 169, name: "Philippines" },
        { id: 176, name: "Romania" },
        { id: 188, name: "Senegal" },
        { id: 197, name: "South Africa" },
        { id: 199, name: "Spain" },
        { id: 200, name: "Sri Lanka" },
        { id: 211, name: "Thailand" },
        { id: 213, name: "Togo" },
        { id: 217, name: "Tunisia" },
        { id: 225, name: "United Kingdom" },
        { id: 232, name: "Viet Nam" }
      ],
      recruiters: [],
      bookerAlreadyWorkedMessage:
        "Este booker ya trabajó: usá Stopped (7) o Standby (3).",
      activeBookerStatusIds: [4, 5, 6, 10, 15, 16],
    };
  },
  created() {
    this.getBookerStatuses();
    this.getBookerManager();
    this.getBookerRecruiters();
  },
  computed: {
    userSelectedIsBdrUser() {
      return this.selected.user.team_role_id == 2 &&
        this.selected.user.role_id == 2
        ? true
        : false;
    },
    discordRequired() {
      return (
        this.selected.user.booker_type !== "ai_agent" &&
        this.activeBookerStatusIds.includes(
          Number(this.selected.user.user_bdr_status_id)
        )
      );
    },
  },
  methods: {
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    isRejectedStatusBlocked(statusId) {
      return (
        !!this.selected.user.booker_has_worked &&
        [8, 12].includes(Number(statusId))
      );
    },
    getBookerStatuses() {
      this.loadingGeneral = false;
      usersService
        .getBookerStatuses()
        .then((res) => {
          this.booker_statuses = res.result;
        })
        .catch((err) => console.log(err));
    },
    getBookerManager() {
      bookersService
        .getBookerManager()
        .then((response) => {
          if (response.status === 200 && response.result.list) {
            this.booker_manager.push(...response.result.list);
          } else {
            this.booker_manager = [];
          }
          this.loadingGeneral = true;
        })
        .catch((err) => console.log(err));
    },
    getBookerRecruiters() {
      usersService
        .getBookerRecruiters()
        .then((res) => {
          this.recruiters = res.result || res;

          if (this.selected.user.recruiter_id == null && this.recruiters.length > 0) {
            const randomIndex = Math.floor(Math.random() * this.recruiters.length);
            this.selected.user.recruiter_id = this.recruiters[randomIndex].id;
          }
        })
        .catch((err) => console.log(err));
    },
    saveInfoUserGeneral() {
      const recruiterId = this.selected.user.recruiter_id || null
      const discord_id = String(this.selected.user.discord_id || "").trim() || null

      const discordError = this.getDiscordIdError(discord_id)
      if (discordError) {
        this.$swal({
          type: "error",
          title: this.$t("lang.label.error"),
          text: discordError,
          showConfirmButton: true,
        });
        return;
      }

      bookersService
        .saveUserGeneral(
          this.selectedUserId,
          this.selected.user.booker_manager_id,
          this.selected.user.setup_call,
          this.selected.user.booker_level_id,
          this.selected.user.booker_notes,
          this.selected.user.user_bdr_status_id,
          this.selected.user.starting_date,
          this.selected.user.country_id,
          recruiterId,
          discord_id,
          this.selected.user.ringover_phone,
          this.selected.user.booker_type,
          this.selected.user.papaya_beneficiary_id,
        )
        .then((res) => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 5000,
          });
          this.$emit("getUser");
        })
        .catch((err) => {
          const conflictingIds = Array.isArray(err && err.conflicting_client_ids)
            ? err.conflicting_client_ids
            : [];

          if (conflictingIds.length > 0) {
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              html: `${this.$t(
                "lang.label.conflictingClientsAlreadyAssigned"
              )}<br><br><strong>${conflictingIds.map((id) => `ID: ${id}`).join("<br>")}</strong>`,
              showConfirmButton: true,
            });
            this.$emit("getUser");
            return;
          }

          const message =
            err && typeof err.result === "string"
              ? err.result
              : typeof err === "string"
                ? err
                : (err && err.error) || this.bookerAlreadyWorkedMessage;
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: message,
            showConfirmButton: true,
          });
        });
    },
    getDiscordIdError(discordId) {
      if (!this.discordRequired) {
        return null;
      }
      if (!discordId) {
        return "El Discord ID es obligatorio para un booker activo (Level 1 o superior)";
      }
      if (!/^\d{17,20}$/.test(discordId)) {
        return "Poné el ID numérico de Discord, no el pseudo";
      }
      return null;
    },
    approveVerification() {
      this.active = true;
      usersService.verificationCodeAdmin(this.selected.user.id);
    },
    unBlock() {
      usersService
        .unBlock(this.selected.user.id)
        .then((result) => {
          if (result != false) {
            this.selected.user.login_attempt = 0;
          }
        })
        .catch((err) => {
          console.log(
            "Ha ocurrido un error, no se puede realizar la operacion"
          );
        });
    },
  },
};
</script>

<style></style>
